import { render, staticRenderFns } from "./PopUpNewAlarm.vue?vue&type=template&id=139058b2&scoped=true"
import script from "./PopUpNewAlarm.vue?vue&type=script&lang=js"
export * from "./PopUpNewAlarm.vue?vue&type=script&lang=js"
import style0 from "./PopUpNewAlarm.vue?vue&type=style&index=0&id=139058b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139058b2",
  null
  
)

export default component.exports